/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Point, Sprite, Texture } from 'pixi.js';
import { GenericObjectPool } from '../../utils/GenericObjectPool';

export class GameObjectPool extends GenericObjectPool {
  public static readonly instance = new GameObjectPool();

  constructor() {
    super();
    this.setObjConstructFunc(Point, () => new Point());
    this.setObjConstructFunc(Sprite, () => new Sprite());
  }

  public getPoint(): Point {
    return this.getObject(Point)!;
  }

  public getSprite(): Sprite {
    const sprite = this.getObject(Sprite)!;

    sprite.destroy = (): void => {
      this.addSprite(sprite);
    };
    return sprite;
  }

  public addSprite(...sprites: (Sprite | null)[]): void {
    sprites.forEach((sprite) => {
      if (!sprite) return;
      if (sprite.destroyed) return;
      if (sprite.parent) sprite.parent.removeChild(sprite);
      sprite.props({
        x: 0,
        y: 0,
        anchor: 0,
        scale: 1,
        alpha: 1,
        visible: true,
        pivot: 0,
        texture: Texture.EMPTY,
        tint: 0xffffff,
        eventMode: 'auto',
        zIndex: 0,
      });
      sprite.removeTweens(true);
      sprite.removeAllListeners();
      this.addObject(Sprite, sprite);
    });
  }

  public addPoint(...points: Point[]): void {
    for (let i = 0; i < points.length; i += 1) {
      const point = points[i];
      point.set(0, 0);
      this.addObject(Point, point);
    }
  }
}
